import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { AuthService } from '../services/auth/auth.service';
import { AppConstants } from '../../app.constants';

@Injectable()
export class AuthGuard  {
  private isValid: boolean;

  constructor(public router: Router, public userService: AuthService) { }

  get valid(): boolean {
    return this.isValid;
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean {

    if (localStorage.getItem(AppConstants.AUTH_DATA_NAME) == null) {
      this.router.navigate(['/Account'], {
        queryParams: { returnUrl: state.url },
      });
      this.isValid = false;
      return false;
    }

    this.isValid = true;
    return true;
  }

}
